exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-1c8e11aa] {\r\n    padding: auto;\r\n    margin-left: 20px;\r\n    padding-top: 20px;\n}\n.my-content[data-v-1c8e11aa] {\r\n    background: #fde2e2;\n}\r\n", ""]);

// exports
